import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router';
import map from 'lodash/map';
import { formatDate, formatDateTime } from '../../../shared/utils/date';
import { ABNORMALITIES, I18N, MANIFEST_BASED } from '../../../constants';
import SmallLoader from '../../SmallLoader/index';

const genericAbnormalityNameFormatter = (cell, row) => {
    if (row.genericAbnormalityType === MANIFEST_BASED) {
        return (
            <Link
                to={`manifests/${row.manifestId}/abnormality/${row.abnormalityType}/${
                    row.dashboardId
                }`}
            >
                {row.abnormalityName}
            </Link>
        );
    }
    return (
        <Link to={`runs/${row.runId}/abnormality/${row.abnormalityType}/${row.dashboardId}`}>
            {row.abnormalityName}
        </Link>
    );
};

const abnormalityNameFormatter = (cell, row) => {
    if (row.genericAbnormalityType && row.genericAbnormalityType !== '') {
        return genericAbnormalityNameFormatter(cell, row);
    }
    return (
        <Link to={`runs/${row.runId}/abnormality/${row.abnormalityType}/${row.dashboardId}`}>
            {row.abnormalityName}
        </Link>
    );
};

const overdueRecActionsListFormatter = (cell, row) => {
    if (row.overdueRecoveryActions && row.overdueRecoveryActions.length > 0) {
        return (
            <div>
                {map(row.overdueRecoveryActions, rec => (
                    <p key={rec.recoveryActionId}>
                        <Link
                            to={`runs/${row.runId}/abnormality/${row.abnormalityType}/${
                                row.dashboardId
                            }/recoveryAction/${rec.recoveryActionType}/${rec.recoveryActionId}`}
                        >
                            {rec.recoveryActionName}
                        </Link>
                    </p>
                ))}
            </div>
        );
    }
    return <div />;
};

const plannedRecActionsListFormatter = (cell, row) => {
    if (row.plannedRecoveryActions && row.plannedRecoveryActions.length > 0) {
        return (
            <div>
                {map(row.plannedRecoveryActions, rec => (
                    <p key={rec.recoveryActionId}>
                        <Link
                            to={`runs/${row.runId}/abnormality/${row.abnormalityType}/${
                                row.dashboardId
                            }/recoveryAction/${rec.recoveryActionType}/${rec.recoveryActionId}`}
                        >
                            {rec.recoveryActionName}
                        </Link>
                    </p>
                ))}
            </div>
        );
    }
    return <div />;
};

const abnormalityTypeFormatter = (cell, row) => {
    return <div className={row.abnormalityType === ABNORMALITIES.BLOWOUT ? "blowoutBackground" :
                           row.abnormalityType === ABNORMALITIES.SHORT_SHIPMENT ? "shortShipmentBackground" :
                           row.abnormalityType === ABNORMALITIES.UNABLE_TO_LOCATE ? "unableToLocateBackground" :
                           row.abnormalityType === ABNORMALITIES.MISCOLLECTION ? "miscollectionBackground" :
                           row.abnormalityType === ABNORMALITIES.DAMAGE ? "damageBackground" :
                           row.abnormalityType === ABNORMALITIES.EARLY_FREIGHT ? "earlyFreightBackground" :
                           row.abnormalityType === ABNORMALITIES.LATE_FREIGHT ? "lateFreightBackground" :
                           row.abnormalityType === ABNORMALITIES.NEW_ORDER ? "newOrderBackground" :
                           row.abnormalityType === ABNORMALITIES.PARTIAL_SHORT_SHIPMENT ? "partialShortShipmentBackground" : ""}>
                            {I18N.ABNORMALITIES[row.abnormalityType]}
    </div>

};

class FollowUpTable extends React.Component {
    render() {
        const { data, isFetching } = this.props;

        const options = {
            defaultSortName: 'abnormalityDate',
            defaultSortOrder: 'desc',
            noDataText: isFetching ? (
                <SmallLoader />
            ) : (
                'No data to display. Please refine your search.'
            ),
        };

        return (
            <BootstrapTable data={data} options={options} pagination striped hover maxHeight={500}>
                <TableHeaderColumn isKey hidden dataField="dashboardId">
                    Abnormality TODO ID
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="abnormalityName"
                    dataFormat={abnormalityNameFormatter}
                    dataSort
                    thStyle={{ whiteSpace: 'normal' }}
                >
                    Abnormality Name
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="abnormalityDate"
                    dataFormat={formatDateTime}
                    dataSort
                    thStyle={{ whiteSpace: 'normal' }}
                >
                    Abnormality Date
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="abnormalityType"
                    // dataFormat={type => I18N.ABNORMALITIES[type]}
                    dataFormat={abnormalityTypeFormatter}
                    dataSort
                    thStyle={{ whiteSpace: 'normal' }}
                >
                    Abnormality Type
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="routeCode"
                    dataSort
                    thStyle={{ whiteSpace: 'normal' }}
                >
                    Route
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="runDate"
                    //dataFormat={formatDate}//-for follow up abnormalities
                    dataSort
                    width="110"
                    thStyle={{ whiteSpace: 'normal' }}
                >
                    Run Date
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="destination"
                    dataSort
                    dataFormat={d => <span title={d}>{d}</span>}
                    thStyle={{ whiteSpace: 'normal' }}
                >
                    Destination
                </TableHeaderColumn>
                <TableHeaderColumn dataField="location" dataSort thStyle={{ whiteSpace: 'normal' }}>
                    Abnormality Location
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="assigneeGroup"
                    dataFormat={ag => <span title={ag}>{ag}</span>}
                    dataSort
                    thStyle={{ whiteSpace: 'normal' }}
                >
                    Assignee Group
                </TableHeaderColumn>
                <TableHeaderColumn dataField="assignee" dataSort thStyle={{ whiteSpace: 'normal' }}>
                    Assignee
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="overdueRecoveryActions"
                    dataFormat={overdueRecActionsListFormatter}
                    thStyle={{
                        whiteSpace: 'normal',
                    }}
                >
                    Overdue Recovery Actions
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="plannedRecoveryActions"
                    dataFormat={plannedRecActionsListFormatter}
                    thStyle={{
                        whiteSpace: 'normal',
                    }}
                >
                    Planned Recovery Actions
                </TableHeaderColumn>
            </BootstrapTable>
        );
    }
}

export default FollowUpTable;
